import { postData } from './PostData';

export const account = () => {
	const removeAccountBtn = document.getElementById('remove-account');
	
	if(removeAccountBtn) {
		removeAccountBtn.addEventListener('click', (e) => {
			e.preventDefault();
			const form = new FormData();
			form.append('action', 'remove_account');
			const params = new URLSearchParams(form);

			// TODO this doesn't work as URL won't exist by described action.
			postData(my_ajax_object.ajax_url, params)
				.then(data => {
					window.location.href = "/prisijungti";
				});
		});
	}
}
